export const SUPPORTED_LANGUAGES = ['ko', 'en'] as const;

export type Language = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: Language = 'ko';

const isLanguage = (language: string): language is Language => SUPPORTED_LANGUAGES.includes(language as Language);

export const createTheme = (language?: string | null) => ({
	language: language && isLanguage(language) ? language : DEFAULT_LANGUAGE
});
